module.exports = __webpack_public_path__ + "img/C7.480cf666.svg";